import { AssetItem, LayoutItem } from "Vendor/Store/studio/initialState"
import { ActiveDragData } from "./StudioTypes"

interface CreateItemFromDragProps {
    activeData: ActiveDragData;
    col_start: number;
    row_start: number;
    size: { col_span: number; row_span: number };
    currentStyle?: React.CSSProperties;
}

const CreateItemFromDrag = ({
    activeData,
    col_start,
    row_start,
    size,
    currentStyle
}: CreateItemFromDragProps): {
    asset: Omit<AssetItem, 'id'>
    desktopLayout: Omit<LayoutItem, 'id' | 'assetId'>
    mobileLayout: Omit<LayoutItem, 'id' | 'assetId'>
} => {
    switch (activeData.itemType) {
        case 'COLOR': {
            const color = activeData.colorValue!

            return {
                asset: {
                    type: activeData.itemType,
                    itemId: activeData.itemId,
                    content: { color },
                    collectionSlug: undefined,
                },
                desktopLayout: {
                    position: { col_start, row_start },
                    size,
                    styles: { backgroundColor: color, ...currentStyle },
                    zIndex: 0,
                },
                mobileLayout: {
                    position: { col_start, row_start},
                    size,
                    styles: { backgroundColor: color, ...currentStyle },
                    zIndex: 0,
                },
            }
        }

        case 'EXTERNAL_IMAGE':
        case 'PRODUCT':
        case 'FILE': {
            return {
                asset: {
                    type: activeData.itemType,
                    itemId: activeData.itemId,
                    collectionSlug: activeData.collectionSlug,
                    content: {
                        src: activeData.imageUrl,
                        alt: activeData.imageAlt || 'image',
                    },
                },
                desktopLayout: {
                    position: { col_start, row_start },
                    size,
                    styles: { objectFit: 'cover', ...currentStyle },
                    zIndex: 0,
                },
                mobileLayout: {
                    position: { col_start, row_start },
                    size,
                    styles: { objectFit: 'cover', ...currentStyle },
                    zIndex: 0,
                },
            }
        }

        case 'TEXT':
            return {
                asset: {
                    type: activeData.itemType,
                    itemId: activeData.itemId,
                    collectionSlug: undefined,
                    content: { text: 'New Text Block' },
                },
                desktopLayout: {
                    position: { col_start, row_start },
                    size,
                    styles: { ...currentStyle },
                    zIndex: 0,
                },
                mobileLayout: {
                    position: { col_start, row_start },
                    size,
                    styles: { ...currentStyle },
                    zIndex: 0,
                },
            }
        default:
            throw new Error('Unsupported item type')
    }
}

export default CreateItemFromDrag;
